
import { Ref, computed, defineComponent, ref } from 'vue'
import { User } from '@/retail/contexts/customers/services/user.service'
import { IdfButton, IdfInput, IdfModal, IdfStandardInputs } from '@invivodf/ui-kit'

export default defineComponent({
  name: 'EditInfoModal',
  components: { IdfModal, IdfButton, IdfInput, IdfStandardInputs },
  props: {
    initialCustomerInfo: {
      type: Object as () => User,
      require: true,
    },
  },
  setup(props, { emit }) {
    const customerInfo = ref({ ...props.initialCustomerInfo } || {}) as Ref<User>
    const isFirstNameInError = computed(() => customerInfo.value.firstName === '')
    const isLastNameInError = computed(() => customerInfo.value.lastName === '')
    const isEmailInError = computed(() => !customerInfo.value.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))

    const onCancel = () => {
      emit('close')
    }

    const onConfirm = () => {
      emit('confirm', customerInfo.value)
    }

    const hasError = computed(() => isFirstNameInError.value || isLastNameInError.value || isEmailInError.value)

    return { onCancel, onConfirm, customerInfo, hasError, isLastNameInError, isFirstNameInError, isEmailInError }
  },
})
